export default {
  getDetailUrl: (id) => `/articles/${id}`
}
